const pjson = require('../package.json')

let type = `/${location.href.replace(location.origin, '').split('/')[1]}` // clients or admin
let role = type.replace('/', '')

type = (type === '/' || type === '/admin') ? '/admin' : '/clients' // if page prepared for admin or client
role = role === '' ? 'admin' : role // checkout user's role

const globalConfig = {
    lang: process.env.VUE_APP_LANG,
    baseUrl: process.env.VUE_APP_URL + type,
    originalUrl: process.env.VUE_APP_URL,
    role,
    socketUrl: process.env.VUE_APP_SOCKET_URL,
    mode: process.env.VUE_APP_MODE,
    behavior: process.env.VUE_APP_BEHAVIOR_PROJECT,
    appVersion: pjson.version,
    googleMapsKey: process.env.GOOGLE_MAPS_KEY,
}

export {
    globalConfig,
}
